import React, { createContext, useContext, useReducer } from 'react'

const defaultState: Recoil.ExploreExpensesQuery = {
	match: {},
	sort: '-timestamps.createdAt',
	paginate: {
		page: 1,
		pageSize: 10,
	},
	textSearch: undefined,
}

const ExpensesQueryContext = createContext<
	[
		Recoil.ExploreExpensesQuery,
		React.Dispatch<{
			type: 'SET' | 'RESET' | 'SET_MATCH'
			payload: Partial<Recoil.ExploreExpensesQuery> | any
		}> | null
	]
>([defaultState, null])

const reducer = (
	state: Recoil.ExploreExpensesQuery,
	{
		type,
		payload,
	}: {
		type: 'SET' | 'RESET' | 'SET_MATCH'
		payload: Partial<Recoil.ExploreExpensesQuery>
	}
): Recoil.ExploreExpensesQuery => {
	switch (type) {
		case 'SET':
			return {
				...state,
				...payload,
			}

		case 'SET_MATCH':
			return {
				...state,
				match: {
					...state.match,
					...payload,
				},
			}

		case 'RESET':
			return defaultState

		default:
			throw new Error(`Unhandled action type: ${type}`)
	}
}

const Provider: React.FC = ({ children }) => {
	const tuple = useReducer(reducer, defaultState)
	return (
		<ExpensesQueryContext.Provider value={tuple}>
			{children}
		</ExpensesQueryContext.Provider>
	)
}

export default () => {
	const context = useContext(ExpensesQueryContext)
	if (context === undefined) {
		throw new Error(
			'useExpensesQuery must be used within ExpensesQueryProvider'
		)
	}

	return context
}

export { Provider as ExpensesQueryProvider }
